import React from "react";
import { AiOutlineGift } from "react-icons/ai";
import { BiMessageSquareDetail } from "react-icons/bi";
import { FiPackage, FiShoppingBag } from "react-icons/fi";
import { MdOutlineLocalOffer } from "react-icons/md";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { backend_url } from "../../../server";

const DashboardHeader = () => {
  const { seller, isLoading } = useSelector((state) => state.seller);

  if (isLoading || !seller) {
    return null; // or show a loader
  }
  return (
    <div className="w-full h-[80px] bg-white shadow sticky top-0 left-0 z-30 flex items-center justify-between px-4">
      <div className="font-500 text-[#152942]">
        <Link to="/">
          <h1>OmniMart</h1>
        </Link>
      </div>
      <div className="flex items-center">
        <div className="flex items-center mr-4">
          <Link to="/dashboard-coupons" className="800px:block hidden">
            <AiOutlineGift
              color="#40B884"
              size={30}
              className="mx-5 cursor-pointer "
            />
          </Link>

          <Link to="/dashboard-events" className="800px:block hidden">
            <MdOutlineLocalOffer
              color="#40B884"
              size={30}
              className="mx-5 cursor-pointer "
            />
          </Link>

          <Link to="/dashboard-products" className="800px:block hidden">
            <FiShoppingBag
              color="#40B884"
              size={30}
              className="mx-5 cursor-pointer "
            />
          </Link>

          <Link to="/dashboard-orders" className="800px:block hidden">
            <FiPackage
              color="#40B884"
              size={30}
              className="mx-5 cursor-pointer "
            />
          </Link>

          <Link to="/dashboard-messages" className="800px:block hidden">
            <BiMessageSquareDetail
              color="#40B884"
              size={30}
              className="mx-5 cursor-pointer "
            />
          </Link>
          <Link to={`/shop/${seller?._id}`}>
            <img
              src={seller.avatar?.url}
              className="w-[50px] h-[50px] rounded-full object-contain border-2 border-[#40B884] cursor-pointer"
              alt=""
            />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DashboardHeader;
